import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { get } from 'utils/lodash'
import { selectAddressName } from 'data/address/addressSelectors'
import T from 'T'

const AddressDisplay = ({ address = {}, addressName = '', variant = 'default', showAddressName = true, sx = {}, parcelNumber = '' }) => {
  const streetAddress = get(address, 'line1', '')
  const unitNumber = get(address, 'unitNumber', '')
  const city = get(address, 'city', '')
  const state = get(address, 'state', '')
  const zipCode = get(address, 'zipCode', '')

  const formattedStreetAddress = [streetAddress, unitNumber].filter(Boolean).join(', ')
  const cityStateZip = [city, `${state} ${zipCode}`.trim()].filter(Boolean).join(', ')

  const displayAddressName = addressName || selectAddressName(address)

  const getTypographyProps = line => {
    switch (variant) {
      case 'compact':
        return {
          streetAddress: { variant: 'body1', fontWeight: 500 },
          addressName: { variant: 'body2', color: 'text.secondary' },
          cityStateZip: { variant: 'body2', color: 'text.secondary' },
        }[line]
      case 'large':
        return {
          streetAddress: { variant: 'h4', fontWeight: 600, color: 'text.primary' },
          addressName: { variant: 'body2', color: 'text.secondary' },
          cityStateZip: { variant: 'body1', color: 'text.primary' },
        }[line]
      default:
        return {
          streetAddress: { variant: 'subtitle1', fontWeight: 600 },
          addressName: { variant: 'body2', color: 'text.secondary' },
          cityStateZip: { variant: 'body2', color: 'text.secondary' },
        }[line]
    }
  }

  return (
    <Box
      sx={{
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        ...sx,
      }}
    >
      {formattedStreetAddress && (
        <Typography {...getTypographyProps('streetAddress')} noWrap>
          {formattedStreetAddress}
        </Typography>
      )}
      {showAddressName && (displayAddressName || parcelNumber) && (
        <Typography {...getTypographyProps('addressName')} noWrap>
          {displayAddressName}
          {parcelNumber && `${displayAddressName ? ' - ' : ''}${T.PARCEL_NUMBER} ${parcelNumber}`}
        </Typography>
      )}
      {cityStateZip && (
        <Typography {...getTypographyProps('cityStateZip')} noWrap>
          {cityStateZip}
        </Typography>
      )}
    </Box>
  )
}

AddressDisplay.propTypes = {
  address: PropTypes.object,
  addressName: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'compact', 'large']),
  showAddressName: PropTypes.bool,
  sx: PropTypes.object,
  parcelNumber: PropTypes.string,
}

export default AddressDisplay
